import { useState, useEffect, useRef } from 'react'
import { SettingsGroup, Control } from './General'
import Form from 'react-bootstrap/Form'
import * as Basic from './BasicFields'


export default function CoordinateModule( props )
{
    const coordinates = props.coordinates
    const setCoordinates = props.setCoordinates
    const selected = props.selected
    const setManual = props.setManual

    const [ x, setX ] = useState(null)
    const [ xError, setXError ] = useState(false)

    const [ y, setY ] = useState(null)
    const [ yError, setYError ] = useState(false)

    const [ width, setWidth ] = useState(null)
    const [ widthError, setWidthError ] = useState(false)

    const [ height, setHeight ] = useState(null)
    const [ heightError, setHeightError ] = useState(false)

    const [ fixedAspect, setFixedAspect ] = useState(true)

    const loaded = useRef(false)
    const isLive = useRef(false)

    const reload = () => {        
        if( coordinates == null )
        {
            return 
        }

        let location = coordinates.location

        isLive.current = false 
        if( coordinates.is_live != null )
        {
            isLive.current = coordinates.is_live
        }

        if( location == null )
        {
            return
        }

        setX( location.x.toFixed(2) )
        setXError( false )
        setY( location.y.toFixed(2) ) 
        setYError( false )
        setWidth( location.width.toFixed(2) )
        setWidthError( false )
        setHeight( location.height.toFixed(2) )
        setHeightError( false )

        setFixedAspect( coordinates.fixed_aspect_ratio )
        loaded.current = true
    }

    const hasChange = () => {
        if( coordinates == null )
        {
            return false;
        }

        let location = coordinates.location


        if( location == null )
        {
            return false;
        }

        if( parseFloat(x) != location.x )
        {
            return true;
        }

        if( parseFloat(y) != location.y )
        {
            return true;
        }

        if( parseFloat(width) != location.width )
        {
            return true;
        }
 
        if( parseFloat(height) != location.height )
        {
            return true;
        }

        return false;
    }

    useEffect( () => {
        loaded.current = false
    },[selected])

    useEffect( () => {
        /*if( loaded.current )
        {
            return
        }*/

        reload()
    },[coordinates])

    useEffect( () => {
    },[])


    useEffect( () => {
        if( isLive.current )
        {
            return
        }
        
        if( x == null || y == null || width == null || height == null || fixedAspect == null )
        {
            return
        }

        if( !hasChange() )
        {
            return
        }

        let hasError = false;
        
        let l = {}

        try {
            l.x = parseFloat(x)
            if (isNaN(l.x)) {
                throw new Error("Invalid number format");
            }
            setXError(false)
        }
        catch 
        {
            setXError(true)
            hasError = true;
        }

        try {
            l.y = parseFloat(y)
            if (isNaN(l.y)) {
                throw new Error("Invalid number format");
            }

            setYError(false)
        }
        catch 
        {
            setYError(true)
            hasError = true;
        }

        try {
            l.width = parseFloat(width)
            if (isNaN(l.width)) {
                throw new Error("Invalid number format");
            }

            setWidthError(false)
        }
        catch 
        {
            setWidthError(true)
            hasError = true;
        }

        try {
            l.height = parseFloat(height)
            if (isNaN(l.height)) {
                throw new Error("Invalid number format");
            }

            setHeightError(false)
        }
        catch 
        {
            setHeightError(true)
            hasError = true;
        }

        //console.log( hasError )
        
        if( !hasError && setManual != null )
        {
            let c = {}
            c.location = l
            c.fixed_aspect_ratio = fixedAspect
            setManual(c)
        }
        

    },[ x,y,width,height, fixedAspect ] )

    if( x == null || y == null || width == null || height == null )
    {
        return ( <></>)
    }

    return (
        <SettingsGroup name="Coordinates">
            <Basic.FloatInput name="X"
                              value={x}
                              setValue={setX}
            /> 
            <Basic.FloatInput name="Y"
                              value={y}
                              setValue={setY}
            />
            <Basic.FloatInput name="Width"
                              value={width}
                              setValue={setWidth}
            />
            <Basic.FloatInput name="Height"
                              value={height}
                              setValue={setHeight}
            />
        </SettingsGroup>
    )
}
